import currency from 'currency.js'

export const toBarChartData = data => {
  if (!data) return {}
  let totalCount = 0
  let totalBidValue = 0
  let totalWonValue = 0
  const keys = ['Bid']
  const barByValue = Object.keys(data).reduce((a, item) => {
    const elem = data[item]
    totalBidValue += elem.totalBidValue
    totalWonValue += elem.totalWonValue
    totalCount += elem.count
    a.push({
      month: item,
      Bid: currency(elem.totalBidValue).value
    })

    return a
  }, [])

  return {
    keys,
    barByValue,
    totalCount,
    totalBidValue,
    totalWonValue
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const getColors = bar => {
  const colors = { Bid: '#595959' }
  return colors[bar.id]
}
